/* eslint-disable */
import { Box, Button, Fade, Modal } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import ModalStepper from "./ModalStepper";
import StepperContentBriefBody from "./StepperContentBriefBody";
import StepperArticleOutlineBody from "./StepperArticleOutlineBody";
import StepperArticleContentBody from "./StepperArticleContentBody";
import { ContentGeneratePopupStyle } from "./css";
import { useState, useEffect } from "react";
import { generateTitle } from "../../../gql/mutations/scrapy";
import { useLazyQuery } from "@apollo/client";

const EqualPopupStyles = { // To make all the three popups equal size
  width: "100%",
  minHeight: "420px",
  maxHeight: "420px",
  display: "flex",
  flexDirection: "column",
};

const stepsLabel = ["Content brief", "Article outline", "Article content"];

function ContentGeneratePopup({ queryId, open, handleClose, contentQuery, generateParagaphHandler, refetchContent, initialTitle, setIsDirty, metaDescription }) {
  const [GENERATE_TITLE] = useLazyQuery(generateTitle, { fetchPolicy: "no-cache" });  //changed network-only to no-cache to avoid caching issues of the generated title function 
  const [loadingTitle, setLoadingTitle] = useState(false);
  const [formData, setFormData] = useState({
    title: contentQuery?.title || "",
    contentType: "blog",
    includeImages: "no", // added to ask user for the image generating choice
    requirements: "",
    outlineHtml: "",
    articleHtml: "",
    wordCount: 3000,
  });

  useEffect(() => {
    if(open){
      setFormData(prev => ({ ...prev, title: initialTitle || "" }));
    }
  }, [open, initialTitle, contentQuery?.title]);

  const updateForm = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const generateTitleHandlerFromPopUp = () => {
    setLoadingTitle(true);
    try {
      GENERATE_TITLE({
        variables: {
          queryId,
        },
        onCompleted: data => {
          let generatedTempTitle = data?.generateTitleByQueryId || "";

          if (generatedTempTitle.startsWith('"') && generatedTempTitle.endsWith('"')) {
            generatedTempTitle = generatedTempTitle.slice(1, -1);
          }

          updateForm("title", generatedTempTitle);
        },

        onError: err => {
          console.log(err, "This is error");
        },
      }).finally(() => {
        setLoadingTitle(false);
      });
     } catch (error) {
        console.error("Error generating title:", error);
        setLoadingTitle(false);
      }
  };


  return (
    <Modal open={open} closeAfterTransition>
      <Fade in={open}>
        <ContentGeneratePopupStyle>
          <Button className="closeBtn" onClick={handleClose}>
            <CancelIcon />
          </Button>
          <Box className="BodyContentWrapper" style={EqualPopupStyles}>
            <ModalStepper refetchContent={refetchContent} stepsLabel={stepsLabel} formData={formData} updateForm={updateForm} contentQuery={contentQuery} handleClose={handleClose} setIsDirty={setIsDirty} metaDescription={metaDescription}>
              <StepperContentBriefBody
                queryId={queryId}
                contentQuery={contentQuery}
                formData={formData}
                updateForm={updateForm}
                generateTitleHandlerFromPopUp={generateTitleHandlerFromPopUp}
                loadingTitle={loadingTitle}
                setLoadingTitle={setLoadingTitle}
              />
              <StepperArticleOutlineBody contentQuery={contentQuery} formData={formData} updateForm={updateForm} />
              <StepperArticleContentBody contentQuery={contentQuery} formData={formData} updateForm={updateForm} />
            </ModalStepper>
          </Box>
        </ContentGeneratePopupStyle>
      </Fade>
    </Modal>
  );
}

export default ContentGeneratePopup;
